import { deleteEmployeeApi } from "../../../../../api/users/employee/employeeApi";

export const UpdateStatusEmployeeUseCase = async (
  employeeId,
  status,
  email
) => {
  try {
    const resp = await deleteEmployeeApi(employeeId, status, email);
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
